// Tracks the last few court forms a user opened (client-side).
const KEY = "nc_recent_forms";
const MAX = 5;

export function getRecentForms() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
}

export function addRecentForm(form) {
  if (!form?.number) return;
  const entry = { number: form.number, title: form.title || form.number };
  const list = [entry, ...getRecentForms().filter((f) => f.number !== form.number)].slice(0, MAX);
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event("nc-recent-forms-changed"));
}
